import type { ComponentType, FC } from 'react';
import {
  Rocket,
  MessagesSquare,
  MessageSquare,
  Paperclip,
  Video,
  Bell,
  Settings as SettingsIcon,
  Download,
  Monitor,
  Globe,
  ShieldCheck,
  HelpCircle,
  ScreenShare,
  CalendarDays,
} from 'lucide-react';
import { GettingStarted } from './GettingStarted';
import { Rooms } from './Rooms';
import { Messaging } from './Messaging';
import { Files } from './Files';
import { Calls } from './Calls';
import { Calendar } from './Calendar';
import { Notifications } from './Notifications';
import { Settings } from './Settings';
import { Updates } from './Updates';
import { WindowTray } from './WindowTray';
import { WebVersion } from './WebVersion';
import { Security } from './Security';
import { RemoteSupport } from './RemoteSupport';
import { Faq } from './Faq';

export interface HelpSection {
  /** 앵커 id (목차 이동에 사용) */
  id: string;
  /** 목차와 본문 머리글에 표시할 제목 */
  title: string;
  /** 한 줄 요약 (본문 머리글 아래) */
  summary: string;
  icon: ComponentType<{ className?: string; size?: number | string }>;
  Body: FC;
}

export const HELP_SECTIONS: HelpSection[] = [
  {
    id: 'start',
    title: '시작하기',
    summary: '설치부터 로그인, 화면 구성까지',
    icon: Rocket,
    Body: GettingStarted,
  },
  {
    id: 'rooms',
    title: '대화방',
    summary: '채널, 그룹, 1:1 대화 만들고 관리하기',
    icon: MessagesSquare,
    Body: Rooms,
  },
  {
    id: 'messaging',
    title: '메시지 주고받기',
    summary: '전송, 답장, 반응, 읽음 표시, 검색',
    icon: MessageSquare,
    Body: Messaging,
  },
  {
    id: 'files',
    title: '파일과 이미지',
    summary: '첨부 방법, 용량 제한, 내려받기',
    icon: Paperclip,
    Body: Files,
  },
  {
    id: 'calls',
    title: '영상 통화',
    summary: '통화, 화면 공유, 녹화, 화이트보드',
    icon: Video,
    Body: Calls,
  },
  {
    id: 'calendar',
    title: '캘린더',
    summary: '내 일정·부서 일정·회사 일정, 반복·알림·참석자·대화방 공유',
    icon: CalendarDays,
    Body: Calendar,
  },
  {
    id: 'notifications',
    title: '알림',
    summary: '알림 설정 세 곳과 문제 해결',
    icon: Bell,
    Body: Notifications,
  },
  {
    id: 'settings',
    title: '설정과 프로필',
    summary: '프로필 사진, 자동 실행, 로그아웃',
    icon: SettingsIcon,
    Body: Settings,
  },
  {
    id: 'updates',
    title: '앱 업데이트',
    summary: '자동 업데이트와 직접 확인하기',
    icon: Download,
    Body: Updates,
  },
  {
    id: 'window',
    title: '창과 트레이',
    summary: 'PC 앱을 완전히 종료하는 방법',
    icon: Monitor,
    Body: WindowTray,
  },
  {
    id: 'web',
    title: '웹 브라우저로 쓰기',
    summary: 'PC 앱과의 차이, 휴대폰에서 사용하기',
    icon: Globe,
    Body: WebVersion,
  },
  {
    id: 'remote-support',
    title: '원격지원',
    summary: '담당자에게 원격지원을 요청해 내 PC 화면을 보여 주고 대신 조작받기',
    icon: ScreenShare,
    Body: RemoteSupport,
  },
  {
    id: 'security',
    title: '보안과 이용 수칙',
    summary: '대화 보관, 감사 알림, 금지 사항',
    icon: ShieldCheck,
    Body: Security,
  },
  {
    id: 'faq',
    title: '자주 묻는 질문',
    summary: '자주 겪는 문제와 해결 방법',
    icon: HelpCircle,
    Body: Faq,
  },
];
